import { render, staticRenderFns } from "./weezysTable.vue?vue&type=template&id=033305b6&scoped=true"
import script from "./weezysTable.vue?vue&type=script&lang=js"
export * from "./weezysTable.vue?vue&type=script&lang=js"
import style0 from "./weezysTable.vue?vue&type=style&index=0&id=033305b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033305b6",
  null
  
)

export default component.exports